import { ToastService } from 'src/app/core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteSupplyCartItemByPkService } from 'src/app/modules/checkout/services/delete-supply-cart-item-by-pk.service';
import { SupplyCart } from 'src/app/modules/checkout/supply-cart';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
export interface PermissionDeniedModalData {
  message: string;
  showContactAdmin?: boolean;
  title?: string;
}

@Component({
  selector: 'app-permission-denied-modal',
  templateUrl: './permission-denied-modal.component.html',
  styleUrls: ['./permission-denied-modal.component.css']
})
export class PermissionDeniedModalComponent {
  constructor(
    private router: Router,
    public _dialogRef: MatDialogRef<PermissionDeniedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PermissionDeniedModalData
  ) {
    // Set defaults if not provided
    this.data.showContactAdmin = this.data.showContactAdmin ?? true;
    this.data.title = this.data.title ?? 'Access Restricted';
  }

  dialogClose(status: string): void {
      // this._dialogRef.close(status);
    
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }
  onContinue(){
      this.dialogClose('no'); // your existing logic
  this.router.navigate(['/profile/membership']);
  }
}